import AndiamoPaiListPage from "./pages/AndiamoPaiListPage.vue";
import AndiamoPaiViewPage from "./pages/AndiamoPaiViewPage.vue";
import AndiamoPaiEventiListPage from "./pages/AndiamoPaiEventiListPage.vue";
import AndiamoAccessiListPage from "./pages/AndiamoAccessiListPage.vue";
import AndiamoErogazioneEditPage from "./pages/AndiamoErogazioneEditPage.vue";
import AndiamoErogazioniInviateListPage from "./pages/AndiamoErogazioniInviateListPage.vue";
import AndiamoUtentiListPage from "./pages/AndiamoUtentiListPage.vue";
import AndiamoUtenteEditPage from "./pages/AndiamoUtenteEditPage.vue";
import AndiamoUtenteViewPage from "./pages/AndiamoUtenteViewPage.vue";

export default {
	AndiamoPaiListPage,
	AndiamoPaiViewPage,
	AndiamoPaiEventiListPage,
	AndiamoAccessiListPage,
	AndiamoErogazioneEditPage,
	AndiamoErogazioniInviateListPage,
	AndiamoUtentiListPage,
	AndiamoUtenteEditPage,
	AndiamoUtenteViewPage,
};
